
const CB = { src: require('~/assets/images/payment_cb.png'), height: 'tw-h-6' }
const VISA = {
  src: require('~/assets/images/payment_visa.png'),
  height: 'tw-h-4',
}
const MASTERCARD = {
  src: require('~/assets/images/payment_mastercard.svg'),
  height: 'tw-h-8',
}

const MARKS = {
  systempay: [CB, VISA, MASTERCARD],
  systempay_applepay: [
    {
      src: require('~/assets/images/payment_apple_pay2.png'),
      height: 'tw-h-7',
    },
  ],
  systempay_googlepay: [
    {
      src: require('~/assets/images/payment_google_pay2.png'),
      height: 'tw-h-7',
    },
  ],
  paypal: [
    { src: require('~/assets/images/payment_paypal2.png'), height: 'tw-h-6' },
  ],
  payplug_oney: [
    { src: require('~/assets/images/payment_oney.png'), height: 'tw-h-7' },
  ],
  check: [
    {
      src: require('~/assets/images/payment_check.png?original'),
      height: 'tw-h-12',
    },
  ],
}

const ICONS = {
  transfer: ['fal', 'university'],
  store: ['fal', 'store'],
}

export default {
  name: 'PaymentMethodInfoItem',
  props: {
    payment: {
      type: Object,
      required: true,
    },
  },
  computed: {
    marks() {
      return MARKS[this.payment.identifier] || []
    },
    icon() {
      return ICONS[this.payment.identifier] || null
    },
    eligibilityNote() {
      const key =
        'pages.paiementSecurise.eligibility.' + this.payment.identifier
      return this.$te(key) ? this.$t(key) : null
    },
    acceptedWallets() {
      const wallets = {
        systempay: [
          {
            src: require('~/assets/images/payment_visa.png'),
            alt: 'Visa',
            class: 'tw-h-3',
          },
          {
            src: require('~/assets/images/payment_mastercard.svg'),
            alt: 'Mastercard',
            class: 'tw-h-5',
          },
          {
            src: require('~/assets/images/payment_apple_pay2.png'),
            alt: 'Apple Pay',
            class: 'tw-h-4',
          },
          {
            src: require('~/assets/images/payment_google_pay2.png'),
            alt: 'Google Pay',
            class: 'tw-h-4',
          },
        ],
      }
      return wallets[this.payment.identifier] || []
    },
  },
}
